import { Grid, Skeleton } from '@mui/material';

const TitlesListSkeleton = () => {
  return (
    <Grid container direction="column" rowGap={1}>
      {Array.from({ length: 5 }).map((_, index) => (
        <Grid item key={`title-item-skeleton-${index}`} component={Skeleton} variant="rounded" height={80} />
      ))}
    </Grid>
  );
};

export default TitlesListSkeleton;
